import React from "react";
import { FaLinkedin } from "react-icons/fa";
import { teamMembers } from "../data";

const OurTeam = () => {
  return (
    <section className="bg-white dark:bg-gray-900">
      <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-sm text-center mb-8 lg:mb-16">
          <h2 className="mb-4 text-3xl md:text-4xl tracking-tight font-serif font-bold text-gray-900 dark:text-white">
            Our Team
          </h2>
          <p className="text-lg md:text-xl text-gray-500 lg:mb-16 dark:text-gray-400">
            Meet the experts driving innovation in AI for high-impact
            industries. Our team combines deep domain knowledge with
            cutting-edge technology to deliver secure, hallucination-free
            solutions tailored for Healthcare, Aerospace, Supply Chain, and
            Complex Manufacturing.
          </p>
        </div>
        <div className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] md:grid-cols-3 gap-8 mb-6 lg:mb-16">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="flex flex-col lg:flex-row items-center bg-gray-50 rounded-lg shadow dark:bg-gray-800 transition duration-300 dark:border-gray-700 hover:scale-105 overflow-hidden"
            >
              <div className="flex-1 w-full">
                <img
                  className="w-full h-64 object-cover transition duration-300 md:h-48 lg:h-48"
                  src={member.image}
                  alt={`${member.name} Avatar`}
                />
              </div>
              <div className="p-2 flex flex-col justify-center flex-1">
                <h3 className="text-xl font-semibold tracking-tight text-gray-900 dark:text-white">
                  {member.name}
                </h3>
                <span className="text-sm text-gray-600 dark:text-gray-400">
                  {member.role}
                </span>
                <p className="mt-3 mb-4 text-sm text-gray-400 dark:text-gray-400">
                  {member.description}
                </p>
                <ul className="flex space-x-3 sm:mt-0 justify-center">
                  <li>
                    <a
                      href={member.linkedin}
                      className="text-gray-500 hover:text-gray-900 dark:hover:text-white"
                    >
                      <FaLinkedin size={20} />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurTeam;
